export default "__VITE_ASSET__ZkdxvXL8__"